import { render, staticRenderFns } from "./BureauKeys.vue?vue&type=template&id=7f66bf68&scoped=true&"
import script from "./BureauKeys.vue?vue&type=script&lang=js&"
export * from "./BureauKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66bf68",
  null
  
)

export default component.exports